import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import { Alert } from '../Alert';
import { jsx as _jsx } from "react/jsx-runtime";
export const FireAlarm = _ref => {
  let {
      type = 'warning'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const systemPrefixedType = `system-${type}`;
  return /*#__PURE__*/_jsx(Alert, Object.assign({
    type: systemPrefixedType
  }, props));
};